import { render, staticRenderFns } from "./materialCloudsOfTask.vue?vue&type=template&id=202ddec6&scoped=true&"
import script from "./materialCloudsOfTask.vue?vue&type=script&lang=js&"
export * from "./materialCloudsOfTask.vue?vue&type=script&lang=js&"
import style0 from "./materialCloudsOfTask.vue?vue&type=style&index=0&id=202ddec6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202ddec6",
  null
  
)

export default component.exports